import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import { teamOptionFromEntity } from 'components/forms/autocomplete/Team';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import FormLangInput from 'components/forms/FormLangInput';
import FormRadio from 'components/forms/FormRadio';
import FormSwitchery from "components/forms/FormSwitchery";
import FormAutocompleteCustom from "components/forms/FormAutocompleteCustom";

class PipelineData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    const typeOptions = [{ label: messages.lead, value: 'lead' }, { label: messages.task, value: 'task' }];

    let optionsNull = {
      profile: {
        company: messages.set_to_null,
        first_name: "null",
        last_name: "null"
      },
      username: "null",
      value: null,
      roles: "null",
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div className="form-group-attached">
                    <FormLangInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormAutocompleteCustom
                      autocompleteType="client"
                      label={messages.pipeline_owner}
                      onChange={this.updateEntity}
                      //urlFilters={{ role: 'ROLE_COMPANY' }}
                      name="owner"
                      value={entity.getOwner()}
                      additionalOptions={optionsNull}
                    />
                    <FormAutocomplete
                      label={messages.default_team}
                      name="defaultTeam"
                      value={teamOptionFromEntity(entity.getDefaultTeam())}
                      meta={entity.getDefaultTeamMetaInformation()}
                      validation={entity.getDefaultTeamValidationResult()}
                      onChange={this.updateEntity}
                      returnValueObject
                      autocompleteType="team"
                      disabled={disabled}
                    />
                    <FormRadio
                      label={messages.type}
                      options={typeOptions}
                      onChange={this.updateEntity}
                      value={entity.getType() ? entity.getType() : 'lead'}
                      name="type"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
PipelineData.defaultProps = {
  inModal: false,
};

export default injectIntl(PipelineData);
